"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {
  '/login': {
    title: 'Log in',
    view: 'Login',
    "public": true,
    locales: {
      az: '/az/login',
      en: '/en/login',
      ru: '/ru/login'
    }
  },
  '/az/login': {
    ref: '/login',
    lang: 'az',
    title: 'Giriş'
  },
  '/en/login': {
    ref: '/login',
    lang: 'en',
    title: 'Log in'
  },
  '/ru/login': {
    ref: '/login',
    lang: 'ru',
    title: 'Войти'
  },
  '/signup': {
    title: 'Sign up',
    view: 'Signup',
    "public": true,
    locales: {
      az: '/az/signup',
      en: '/en/signup',
      ru: '/ru/signup'
    }
  },
  '/az/signup': {
    ref: '/signup',
    lang: 'az',
    title: 'Qeydiyyat'
  },
  '/en/signup': {
    ref: '/signup',
    lang: 'en',
    title: 'Sign up'
  },
  '/ru/signup': {
    ref: '/signup',
    lang: 'ru',
    title: 'Регистрация'
  },
  '/remind': {
    title: 'Remind password',
    view: 'Remind',
    "public": true,
    locales: {
      az: '/az/remind',
      en: '/en/remind',
      ru: '/ru/remind'
    }
  },
  '/az/remind': {
    ref: '/remind',
    lang: 'az',
    title: 'Şifrəni xatırlat'
  },
  '/en/remind': {
    ref: '/remind',
    lang: 'en',
    title: 'Remind password'
  },
  '/ru/remind': {
    ref: '/remind',
    lang: 'ru',
    title: 'Напомнить пароль'
  },
  '/new-password': {
    title: 'New password',
    view: 'NewPassword',
    "public": true,
    locales: {
      az: '/az/new-password',
      en: '/en/new-password',
      ru: '/ru/new-password'
    }
  },
  '/az/new-password': {
    ref: '/new-password',
    lang: 'az',
    title: 'Yeni şifrə'
  },
  '/en/new-password': {
    ref: '/new-password',
    lang: 'en',
    title: 'New password'
  },
  '/ru/new-password': {
    ref: '/new-password',
    lang: 'ru',
    title: 'Новый пароль'
  },
  '/cabinet': {
    title: 'Personal cabinet',
    view: 'Cabinet',
    locales: {
      az: '/az/cabinet',
      en: '/en/cabinet',
      ru: '/ru/cabinet'
    }
  },
  '/az/cabinet': {
    ref: '/cabinet',
    lang: 'az',
    title: 'Şəxsi kabinet'
  },
  '/en/cabinet': {
    ref: '/cabinet',
    lang: 'en',
    title: 'Personal cabinet'
  },
  '/ru/cabinet': {
    ref: '/cabinet',
    lang: 'ru',
    title: 'Личный кабинет'
  },
  '/cabinet/change-password': {
    title: 'Change password',
    view: 'ChangePassword',
    locales: {
      az: '/az/cabinet/change-password',
      en: '/en/cabinet/change-password',
      ru: '/ru/cabinet/change-password'
    }
  },
  '/az/cabinet/change-password': {
    ref: '/cabinet/change-password',
    lang: 'az',
    title: 'Şifrəni dəyişdir'
  },
  '/en/cabinet/change-password': {
    ref: '/cabinet/change-password',
    lang: 'en',
    title: 'Change password'
  },
  '/ru/cabinet/change-password': {
    ref: '/cabinet/change-password',
    lang: 'ru',
    title: 'Сменить пароль'
  },
  '/cart': {
    title: 'Shopping cart',
    view: 'Cart',
    "public": true,
    locales: {
      az: '/az/cart',
      en: '/en/cart',
      ru: '/ru/cart'
    }
  },
  '/az/cart': {
    ref: '/cart',
    lang: 'az',
    title: 'Səbət'
  },
  '/en/cart': {
    ref: '/cart',
    lang: 'en',
    title: 'Shopping cart'
  },
  '/ru/cart': {
    ref: '/cart',
    lang: 'ru',
    title: 'Корзина'
  },
  '/wishlist': {
    title: 'Wishlist',
    view: 'Wishlist',
    "public": true,
    locales: {
      az: '/az/wishlist',
      en: '/en/wishlist',
      ru: '/ru/wishlist'
    }
  },
  '/az/wishlist': {
    ref: '/wishlist',
    lang: 'az',
    title: 'İstəklər'
  },
  '/en/wishlist': {
    ref: '/wishlist',
    lang: 'en',
    title: 'Wishlist'
  },
  '/ru/wishlist': {
    ref: '/wishlist',
    lang: 'ru',
    title: 'Избранное'
  },
  '/compare': {
    title: 'Compare',
    view: 'Compare',
    "public": true,
    locales: {
      az: '/az/compare',
      en: '/en/compare',
      ru: '/ru/compare'
    }
  },
  '/az/compare': {
    ref: '/compare',
    lang: 'az',
    title: 'Müqayisə'
  },
  '/en/compare': {
    ref: '/compare',
    lang: 'en',
    title: 'Compare'
  },
  '/ru/compare': {
    ref: '/compare',
    lang: 'ru',
    title: 'Сравнить'
  },
  '/checkout': {
    title: 'Checkout',
    view: 'Checkout',
    "public": true,
    locales: {
      az: '/az/checkout',
      en: '/en/checkout',
      ru: '/ru/checkout'
    }
  },
  '/az/checkout': {
    ref: '/checkout',
    lang: 'az',
    title: 'Sifarişi tamamla'
  },
  '/en/checkout': {
    ref: '/checkout',
    lang: 'en',
    title: 'Checkout'
  },
  '/ru/checkout': {
    ref: '/checkout',
    lang: 'ru',
    title: 'Оформить заказ'
  },
  '/cabinet/orders': {
    title: 'My Orders',
    view: 'CabinetOrders',
    locales: {
      az: '/az/cabinet/orders',
      en: '/en/cabinet/orders',
      ru: '/ru/cabinet/orders'
    }
  },
  '/az/cabinet/orders': {
    ref: '/cabinet/orders',
    lang: 'az',
    title: 'Sifarişlərim'
  },
  '/en/cabinet/orders': {
    ref: '/cabinet/orders',
    lang: 'en',
    title: 'My orders'
  },
  '/ru/cabinet/orders': {
    ref: '/cabinet/orders',
    lang: 'ru',
    title: 'Мои заказы'
  },
  '/cabinet/address': {
    title: 'My address',
    view: 'CabinetAddress',
    locales: {
      az: '/az/cabinet/address',
      en: '/en/cabinet/address',
      ru: '/ru/cabinet/address'
    }
  },
  '/az/cabinet/address': {
    ref: '/cabinet/address',
    lang: 'az',
    title: 'Mənim ünvanım'
  },
  '/en/cabinet/address': {
    ref: '/cabinet/address',
    lang: 'en',
    title: 'My address'
  },
  '/ru/cabinet/address': {
    ref: '/cabinet/address',
    lang: 'ru',
    title: 'Мой адрес'
  },
  '/order': {
    title: 'Order',
    view: 'Order',
    "public": true,
    locales: {
      az: '/az/order',
      en: '/en/order',
      ru: '/ru/order'
    }
  },
  '/az/order': {
    ref: '/order',
    lang: 'az',
    title: 'Sifariş'
  },
  '/en/order': {
    ref: '/order',
    lang: 'en',
    title: 'Order'
  },
  '/ru/order': {
    ref: '/order',
    lang: 'ru',
    title: 'Заказ'
  },
  '/order/error': {
    title: 'Order canceled',
    view: 'OrderError',
    "public": true,
    locales: {
      az: '/az/order/error',
      en: '/en/order/error',
      ru: '/ru/order/error'
    }
  },
  '/az/order/error': {
    ref: '/order/error',
    lang: 'az',
    title: 'Sifariş alınmadı'
  },
  '/en/order/error': {
    ref: '/order/error',
    lang: 'en',
    title: 'Order canceled'
  },
  '/ru/order/error': {
    ref: '/order/error',
    lang: 'ru',
    title: 'Заказ отменен'
  }
};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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